import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { FullStoryEventDirective } from '@directives/fullstory-event.directive';

@Component({
  selector: 'hsc-how-it-works',
  imports: [CommonModule, FullStoryEventDirective],
  template: `
    <div class="bg-primary-container w-full px-12 py-12.5">
      <div class="bolt-container">
        <div class="mb-8">
          <h2 class="bolt-heading-sm text-center">How it works</h2>
        </div>
        <div>
          <div class="grid grid-cols-3 gap-8">
            <div class="flex flex-col items-center rounded-lg p-4">
              <div
                hscFsEventName="Get Covered Icon Clicked"
                class="mb-4 flex h-[115.2px] w-[120px] items-center justify-center"
              >
                <img src="/icons/covered-icon.svg" alt="Get Covered" />
              </div>
              <div class="text-center">
                <h3 class="text-vibrant-blue font-sans-serif mb-2 text-lg font-medium">Get covered</h3>
                <p class="text-md font-sans-serif mb-2 font-normal">
                  Take care of your home with a warranty plan from Nationwide. This plan helps with repair or
                  replacement costs when a covered system or appliance breaks down. Coverage starts after a 30-day
                  waiting period.
                </p>
              </div>
            </div>
            <div class="flex flex-col items-center rounded-lg p-4">
              <div
                hscFsEventName="Something Broke Icon Clicked"
                class="mb-4 flex h-[115.2px] w-[120px] items-center justify-center"
              >
                <img src="/icons/broke-icon.svg" alt="Get help!" />
              </div>
              <div class="text-center">
                <h3 class="text-vibrant-blue font-sans-serif mb-2 text-lg font-medium">Get help!</h3>
                <p class="text-md font-sans-serif mb-2 font-normal">
                  Contact us online or by phone to start your claim. We'll connect you with a qualified technician and
                  collect the service fee, or explain how to use a provider you choose.
                </p>
              </div>
            </div>
            <div class="flex flex-col items-center rounded-lg p-4">
              <div
                hscFsEventName="Technician Icon Clicked"
                class="mb-4 flex h-[115.2px] w-[120px] items-center justify-center"
              >
                <img src="/icons/technician-icon.svg" alt="Get back to normal" />
              </div>
              <div class="text-center">
                <h3 class="text-vibrant-blue font-sans-serif mb-2 text-lg font-medium">Get back to normal</h3>
                <p class="text-md font-sans-serif mb-2 font-normal">
                  Once your repair is complete, we'll pay the contractor directly or quickly reimburse you for covered
                  repairs by the provider you chose.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class HowItWorks {}
